import { render, staticRenderFns } from "./UserEventReportForm.vue?vue&type=template&id=24aa6158"
import script from "./UserEventReportForm.vue?vue&type=script&lang=js"
export * from "./UserEventReportForm.vue?vue&type=script&lang=js"
import style0 from "./UserEventReportForm.vue?vue&type=style&index=0&id=24aa6158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports